import { RoundedBox } from '@react-three/drei'
import * as THREE from 'three'
import { CachedMeshPhysicalMaterial } from '../../../../material/cachedMeshPhysicalMaterial'
import { ColorRepresentation } from 'three'

interface Props {
  position: [number, number, number]
  spaceY: number
  color: ColorRepresentation
}

export const Holder = ({ position, spaceY, color }: Props): JSX.Element => {
  const rodHolder = {
    width: 0.02,
    height: 0.008,
    length: 0.05,
  }

  const rod = {
    width: 0.01,
    height: 0.01,
    length: spaceY - rodHolder.height,
  }

  return (
    <group position={position}>
      {[...Array(2)].map((_, index) => {
        return (
          <RoundedBox
            key={'rodHolder' + index}
            args={[rodHolder.height, rodHolder.width, rodHolder.length]}
            position={[
              index ? -rodHolder.height / 2 : -spaceY + rodHolder.height / 2,
              0,
              0,
            ]}
            radius={0.001}
            castShadow
            receiveShadow
          >
            <CachedMeshPhysicalMaterial color={color} />
          </RoundedBox>
        )
      })}

      <RoundedBox
        args={[rod.length, rod.width, rod.height]}
        position={[-rod.length / 2 - rodHolder.height, 0, 0]}
        radius={0.001}
        castShadow
        receiveShadow
      >
        <CachedMeshPhysicalMaterial color={color} />
      </RoundedBox>
    </group>
  )
}
